<template>
  <div class="list-view">
    <b-overlay
        :key="forceUpdateKey"
        :show="loading"
        rounded="sm"
        spinner-variant="success"
        spinner-type="grow"
    >
      <div class="list-wrapper pb-2">
        <div v-if="listData && listData.length > 0">
          <div
              class="list-item my-2 d-flex border rounded cursor-pointer custom-hover p-3"
              v-for="(item, index) in listData"
              :key="'listViewItem' + index"
              @click="redirectToDetailView(item)"
              style="min-height: 103px;"
          >
            <div class="list-label flex-fill px-2">
              <b-row>
                <b-col>
                  <span>{{ trimSubject(item.subject) }}</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col class="text-muted small">
                  {{ formatRelativeDate(item.lastMessageSent) }}
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
        <div v-else class="max-content-width mx-auto mb-2">
          <div class="max-content-width mx-auto mb-2">

          </div>
          <div class="max-content-width mx-auto">
            Kérdéseid megválaszoltuk!
          </div>
        </div>
      </div>

      <!--
      <div
        v-if="enablePagination && listData && listData.length > 0"
        class="pagination-wrapper"
      >

      </div>
      -->
    </b-overlay>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import moment from "moment";
import 'moment/locale/hu';

export default {
  name: "TicketView",

  props: {
    tickets: {
      type: Array,
    },
    apiLoading: {
      type: Boolean,
      default: true
    },
    detailView: {
      type: String,
    },
    displayProp: {
      type: String,
      default: "content",
    },
    backRouterLink: {
      type: String,
      default: null,
    },
    displayAll: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      listData: [],
      currentPage: 0,
      rowsNumber: 1,
      perPage: 3,
      loading: false,
      forceUpdateKey: 0,
    };
  },
  methods: {
    formatRelativeDate(timestamp){
      const date = moment(timestamp);
      if (moment().diff(date, 'days') > 2) {
        return date.format('YYYY.MM.DD.');
      } else {
        return date.fromNow();
      }
    },
    getUrlData() {
      if (this.$route.query.pageNumber) {
        this.currentPage = this.$route.query.pageNumber;
        this.perPage = this.$route.query.perPage;
      }
    },

    getImgUrl(src) {
      let images = require.context("@/assets/img/", false);
      return images("./" + src);
    },

    redirectToDetailView(item) {

      // enable this on dev to skip missive archive modal
      // this.$router.push("/app/tickets/" + item.uuid);


      const lastMessageDate = new Date(item.lastMessageSent);
      const specifiedDate = new Date('2024-04-17T18:00:00');

      if (lastMessageDate < specifiedDate) {
        this.$bvModal.msgBoxOk('Értesítünk, hogy a 2024 április 17. előtti üzeneteket archiváltuk. Ha korábbi kommunikációidat szeretnéd megtekinteni, kérjük, lépj kapcsolatba ügyfélszolgálatunkkal az alábbi elérhetőségeken: hello@acounto.com', {
          title: 'Archivált üzenet',
          size: 'md',
          buttonSize: 'md',
          okVariant: 'success',
          headerClass: 'p-2 border-bottom-0',
          footerClass: 'p-2 border-top-0',
          centered: true
        });
      } else {
        this.$router.push("/app/tickets/" + item.uuid);
      }

    },

    buttonName(item) {
      if (item.isClosed) {
        return "Megválaszolva"
      } else if (!item.waitingForUserResponse) {
        return "Folyamatban"
      } else if (item.waitingForUserResponse) {
        return "Válaszra vár"
      }

    },
    trimSubject(subject) {
      return subject.length > 45 ? subject.substring(0, 45) + '...' : subject;
    },
    resetRouter() {
      if (this.$route.query.time) {
        this.$router.push("/app/home");
        return false;
      } else {
        return true;
      }
    },
  },
  created() {
    if (this.resetRouter()) {
      this.perPage = this.itemPerPage ? this.itemPerPage : 3;
      this.getUrlData();
    }
    this.listData = this.tickets;

  },
  computed: {
    ...mapGetters("app", ["getActiveCompany"]),
  },
  watch: {
    tickets: {
      handler: function (newVal) {
        this.listData = newVal
        this.forceUpdateKey++;
      },
      deep: true
    },
  },
};
</script>

<style scoped>
.max-content-width {
  width: max-content;
}

.empty-list-image {
  width: 75px;
}

.list-icon {
  width: 25px;
  text-align: center;
  display: flex;
  flex-shrink: 0;
  align-items: center;
}

.list-label {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.list-button-wrapper {
  width: 200px;
  display: flex;
  flex-shrink: 0;
  align-items: center;
}

.list-button {
  text-align: center;
  border: none;
  border-radius: 5px;
  cursor: default;
}

.list-button.read {
  background-color: #ffe2e5;
  color: #f64e60;
}

.list-button.unread {
  background-color: #fff4de;
  color: #ffa800;
}

.list-button.done {
  background-color: lightgreen;
  color: green;
}

.list-button.filed {
  background-color: #fff4de;
  color: #ffa800;
}

.list-button.jam {
  background-color: #ffe2e5;
  color: #f64e60;
}

i.fas.fa-key {
  font-size: 10vw !important;
  max-font-size: 50px !important;
  min-font-size: 20px !important;
}

</style>
